// Hijri (Umm al-Qura, official Saudi calendar) helpers, evaluated in Makkah time.
export const MAKKAH_TZ = "Asia/Riyadh";
const MAKKAH_OFFSET_H = 3; // UTC+3, no DST
const DAY_MS = 86400000;

const fmt = new Intl.DateTimeFormat("en-u-ca-islamic-umalqura-nu-latn", {
  timeZone: MAKKAH_TZ, day: "numeric", month: "numeric", year: "numeric",
});

// Hijri {day, month, year} for a Date; `correction` shifts the Umm al-Qura result by ±1 day
// (e.g. -1 when the official moon-sighting announcement lags the printed calendar).
export function toHijri(date = new Date(), correction = 0) {
  const d = new Date(date.getTime() + correction * DAY_MS);
  const p = {};
  fmt.formatToParts(d).forEach((x) => { if (x.type !== "literal") p[x.type] = parseInt(x.value, 10); });
  return { day: p.day, month: p.month, year: p.year };
}

// Local-noon Date for the Gregorian day that carries a given Hijri date (searches ±2 years).
export function fromHijri(day, month, year, correction = 0) {
  const start = new Date();
  start.setHours(12, 0, 0, 0);
  for (let i = -800; i <= 800; i++) {
    const d = new Date(start.getTime() + i * DAY_MS);
    const h = toHijri(d, correction);
    if (h.day === day && h.month === month && h.year === year) return d;
  }
  return null;
}

// UTC instant for a Makkah wall-clock time on the Gregorian day of `date`.
export function makkahTime(date, hour, minute = 0) {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: MAKKAH_TZ, year: "numeric", month: "2-digit", day: "2-digit" })
    .formatToParts(date);
  const g = {};
  parts.forEach((x) => { if (x.type !== "literal") g[x.type] = parseInt(x.value, 10); });
  return new Date(Date.UTC(g.year, g.month - 1, g.day, hour - MAKKAH_OFFSET_H, minute));
}

export const addDays = (date, n) => new Date(date.getTime() + n * DAY_MS);
